export enum Paginar {
  NAO = 0,
  SIM = 1,
}